<div [formGroup]="metricSelectionForm">
  <mat-form-field appearance="outline" floatLabel="always" class="width-100-percent">
    <mat-label>Select metric</mat-label>
    <mat-select formControlName="metric_id">
      <mat-option (click)="onChangeMetric(item)" [value]="item.id" *ngFor="let item of metricOptionList">{{ item.name }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
